<div class="multiple-image-section">
    <div class="container">
        <!-- Title -->
        <div class="section-title-wrap" *ngIf="inputData?.TitleEn">
            <h2 class="section-main-title">{{ inputData.TitleEn }}</h2>
            <div class="title-underline"></div>
        </div>

        <!-- Description if available -->
        <div class="section-desc-card" *ngIf="inputData?.DetailsEn && inputData.DetailsEn.trim() !== ''">
            <div class="desc-content" [innerHTML]="inputData.DetailsEn"></div>
        </div>

        <!-- Empty State -->
        <div class="empty-state-box" *ngIf="!inputData?.ShowAttachments || inputData.ShowAttachments.length === 0">
            <div class="empty-icon">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                    <circle cx="8.5" cy="8.5" r="1.5"></circle>
                    <polyline points="21 15 16 10 5 21"></polyline>
                </svg>
            </div>
            <h3>No Images Available</h3>
            <p>There are currently no gallery images to display in this category.</p>
        </div>

        <!-- Main Showcase & Gallery Content -->
        <div class="gallery-showcase-wrapper" *ngIf="inputData?.ShowAttachments && inputData.ShowAttachments.length > 0">
            
            <!-- 1. BIG FEATURED IMAGE ON TOP -->
            <div class="featured-image-showcase">
                <div class="featured-image-card" (click)="openLightbox(selectedIndex)">
                    <img 
                        [src]="selectedImage?.FilePath || inputData.ShowAttachments[0]?.FilePath" 
                        [alt]="selectedImage?.Title || inputData.TitleEn || 'Featured Image'"
                        class="featured-img"
                        loading="eager"
                    />
                    
                    <!-- Overlay with Caption & Zoom Icon -->
                    <div class="featured-overlay">
                        <div class="featured-caption" *ngIf="selectedImage?.Title && selectedImage.Title.trim() !== ''">
                            <h4>{{ selectedImage.Title }}</h4>
                        </div>
                        <div class="zoom-badge">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <circle cx="11" cy="11" r="8"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                <line x1="11" y1="8" x2="11" y2="14"></line>
                                <line x1="8" y1="11" x2="14" y2="11"></line>
                            </svg>
                            <span>Click to Zoom</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 2. GALLERY GRID SECTION BELOW -->
            <div class="gallery-grid-section">
                <div class="gallery-section-header">
                    <h3 class="gallery-subheading">
                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <rect x="3" y="3" width="7" height="7"></rect>
                            <rect x="14" y="3" width="7" height="7"></rect>
                            <rect x="14" y="14" width="7" height="7"></rect>
                            <rect x="3" y="14" width="7" height="7"></rect>
                        </svg>
                        <span>Photo Gallery ({{ inputData.ShowAttachments.length }} Photos)</span>
                    </h3>
                </div>

                <div class="gallery-grid">
                    <div 
                        class="gallery-item-card" 
                        *ngFor="let item of inputData.ShowAttachments; let i = index"
                        [class.gallery-item-card--active]="i === selectedIndex"
                        (click)="selectImage(item, i)"
                    >
                        <div class="gallery-thumb-wrap">
                            <img [src]="item.FilePath" [alt]="item.Title || 'Gallery Thumbnail'" class="gallery-thumb" loading="lazy" />
                            <div class="thumb-hover-overlay">
                                <button type="button" class="thumb-zoom-btn" (click)="$event.stopPropagation(); openLightbox(i)">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                        <circle cx="11" cy="11" r="8"></circle>
                                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                        <line x1="11" y1="8" x2="11" y2="14"></line>
                                        <line x1="8" y1="11" x2="14" y2="11"></line>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="gallery-thumb-title" *ngIf="item.Title && item.Title.trim() !== ''">
                            <p>{{ item.Title }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 3. LIGHTBOX MODAL -->
        <div class="lightbox-modal" *ngIf="lightboxOpen" (click)="closeLightbox()">
            <div class="lightbox-dialog" (click)="$event.stopPropagation()">
                <button type="button" class="lightbox-close" (click)="closeLightbox()">
                    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                </button>

                <button type="button" class="lightbox-nav lightbox-prev" (click)="prevLightbox($event)" *ngIf="inputData.ShowAttachments.length > 1">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="15 18 9 12 15 6"></polyline>
                    </svg>
                </button>

                <div class="lightbox-media">
                    <img 
                        [src]="inputData.ShowAttachments[lightboxIndex]?.FilePath" 
                        [alt]="inputData.ShowAttachments[lightboxIndex]?.Title || 'Preview'" 
                        class="lightbox-img"
                    />
                    <div class="lightbox-caption" *ngIf="inputData.ShowAttachments[lightboxIndex]?.Title">
                        <p>{{ inputData.ShowAttachments[lightboxIndex]?.Title }}</p>
                    </div>
                </div>

                <button type="button" class="lightbox-nav lightbox-next" (click)="nextLightbox($event)" *ngIf="inputData.ShowAttachments.length > 1">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="9 18 15 12 9 6"></polyline>
                    </svg>
                </button>
            </div>
        </div>
    </div>
</div>
